// Module
var code = "<!-- ko let: { $nodes: $componentTemplateNodes } -->\n<fc-popper params=\"target: target, show: show, options: options, behavior: {\n    control: true\n  }\" class=\"fc-status-popper\" data-bind=\"attr: {\n    'data-mode': mode\n  }\">\n  <!-- ko template: {\n    nodes: $nodes\n  } -->\n  <!-- /ko -->\n</fc-popper>\n<!-- /ko -->\n";
// Exports
module.exports = code;